import SidebarLayout from './SidebarLayout';
import { APP_NAV } from './nav';

/** Main consumer layout (dashboard, calls, review queue, reports). */
export default function AppLayout() {
  return <SidebarLayout nav={APP_NAV} title="پایش مرکز تماس" />;
}
